<template>
    <span v-if="mins">{{ theTime }}</span>
</template>

<script>
export default {
    name: 'time-2-make',
    props: ['mins'],
    computed: {
        theTime () {
            if (this.mins < 60) {
                return this.mins + " mins";
            } else {
                const hours = Math.floor(this.mins / 60);
                const remainder = this.mins % 60;
                return hours + (hours > 1 ? " hours ": " hour ") + (remainder > 1 ? remainder + " mins" : remainder > 0 ? remainder + " min" : "");
            }
        }
    }
}
</script>
